import { SDSColors } from '@assethub/shared/utils';

export type FirmwareState = 'CURRENT' | 'UPDATE_AVAILABLE' | 'UNKNOWN';

export const AVAILABLE_FIRMWARE_STATES: FirmwareState[] = [
  'CURRENT',
  'UPDATE_AVAILABLE',
  'UNKNOWN',
];

export const FIRMWARE_STATE_FILTER_ICON: Record<
  FirmwareState,
  { shape: string; color: string; label: string }
> = {
  CURRENT: {
    shape: 'check',
    color: SDSColors.success,
    label: 'asset.firmware.state.CURRENT.displayLabel',
  },
  UPDATE_AVAILABLE: {
    shape: 'warning',
    color: SDSColors.primary,
    label: 'asset.firmware.state.UPDATE_AVAILABLE.displayLabel',
  },
  UNKNOWN: {
    shape: 'help',
    color: SDSColors.secondary,
    label: 'asset.firmware.state.UNKNOWN.displayLabel',
  },
};
